import { render, staticRenderFns } from "./BaseTile.vue?vue&type=template&id=b498b2da&scoped=true&"
import script from "./BaseTile.vue?vue&type=script&lang=js&"
export * from "./BaseTile.vue?vue&type=script&lang=js&"
import style0 from "./BaseTile.vue?vue&type=style&index=0&id=b498b2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b498b2da",
  null
  
)

export default component.exports